import { DisposalSet, onReadyEach, select, selectAll } from '@neptune/cx/utils';
import './styles.scss';
import {
    addToMultiParamMap,
    removeFromMultiParamMap,
    toMultiParamMap,
    toURLSearchParams,
    updateResults
} from '../../fragments/layouts/ay-search-layout/facets';

const gc = new DisposalSet();

const initCategoryListFacet = (facetEl: HTMLDivElement, pageParam: string) => {
    const parentFormEl = facetEl.closest('form');
    const searchLayoutEl = facetEl.closest<HTMLDivElement>('.ay-search-layout');
    if (!parentFormEl || !searchLayoutEl) return;

    const facetParamName = select<HTMLInputElement>(parentFormEl, 'input.facet-parameter-name');
    const listItemCheckboxEls = selectAll<HTMLInputElement>(facetEl, '.ay-category-list-facet__item input[type="checkbox"]');

    for (const checkboxEl of listItemCheckboxEls) {
        (gc.register(checkboxEl)
            .addListener('change', (e) => {
                const multiParamMap = toMultiParamMap(new URLSearchParams(window.location.search));
                const value = checkboxEl.value;
                if (checkboxEl.checked) {
                    addToMultiParamMap(multiParamMap, facetParamName.value, value);
                } else {
                    removeFromMultiParamMap(multiParamMap, facetParamName.value, value);
                }
                removeFromMultiParamMap(multiParamMap, pageParam, null);
                const params = toURLSearchParams(multiParamMap);
                const nextUrl = `${window.location.pathname}?${params}`;
                updateResults(searchLayoutEl, nextUrl, pageParam);
            })
        );
    }
};

export const reinit = (parentEl: HTMLDivElement, replacements: HTMLDivElement[], pageParam: string) => {
    gc.disposeAll();
    const facetEls = selectAll<HTMLDivElement>(parentEl, '.ay-category-list-facet');
    for (let i = 0; i < facetEls.length; i++) {
        const facetEl = facetEls[i];
        const replacementFacetEl = replacements[i];

        if (replacementFacetEl) {
            facetEl.replaceWith(replacementFacetEl);
            initCategoryListFacet(replacementFacetEl, pageParam);
        }
    }
}

onReadyEach<HTMLDivElement>('.ay-category-list-facet', facetEl => {
    initCategoryListFacet(facetEl, facetEl.dataset.pageParam || 'start')
});

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}